module.exports = __webpack_public_path__ + "img/大全集团LOGO.7eb8a994.png";